(() => {
  'use strict';

  const ajaxUrl = (route) => (route.endsWith('.js') ? route : `${route}.js`);

  const updateCartCount = (count) => {
    document.querySelectorAll('.cart-button').forEach((button) => {
      button.dataset.cartCount = String(count);
      const label = button.getAttribute('aria-label') || '';
      button.setAttribute('aria-label', label.replace(/\d+/, String(count)));
    });
  };

  const ensurePageInteractive = () => {
    window.NNLReleasePage?.();
    document.body.classList.remove('drawer-open', 'intro-active');
    document.body.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow');
    document.documentElement.classList.add('nnl-intro-skip', 'nnl-page-released');
    document.querySelectorAll('[data-drawer].is-open').forEach((drawer) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-drawer-open][aria-expanded="true"]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
    document.querySelector('[data-intro]')?.remove();
  };

  const keepPageInteractive = () => {
    ensurePageInteractive();
    window.requestAnimationFrame(ensurePageInteractive);
    window.setTimeout(ensurePageInteractive, 180);
    window.setTimeout(ensurePageInteractive, 700);
  };

  const setFormState = (form, pending) => {
    form.toggleAttribute('aria-busy', pending);
    form.dataset.cartPending = pending ? 'true' : 'false';
    form.querySelectorAll('[type="submit"]').forEach((button) => {
      button.toggleAttribute('disabled', pending);
    });
  };

  const showMessage = (form, message, isError = false) => {
    const productMessage = form.querySelector('[data-product-form-message]');
    if (productMessage) {
      productMessage.textContent = message;
      productMessage.classList.toggle('is-error', isError);
    }
    window.NNLShowToast?.(message);
  };

  const addProduct = async (form) => {
    if (form.dataset.cartPending === 'true') return;

    keepPageInteractive();
    setFormState(form, true);
    const previousMessage = form.querySelector('[data-product-form-message]');
    if (previousMessage) {
      previousMessage.textContent = '';
      previousMessage.classList.remove('is-error');
    }

    try {
      const response = await fetch(ajaxUrl(window.NNL.routes.cartAdd), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.description || data.message || window.NNL.strings.error);
      }

      try {
        const cartResponse = await fetch(ajaxUrl(window.NNL.routes.cart), {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          updateCartCount(cart.item_count || 0);
        }
      } catch (error) {
        // Produkt został dodany; licznik odświeży się przy następnym załadowaniu strony.
      }

      showMessage(form, window.NNL.strings.added);
      keepPageInteractive();
      document.dispatchEvent(new CustomEvent('nnl:cart-updated', { detail: data }));
    } catch (error) {
      showMessage(form, error.message || window.NNL.strings.error, true);
    } finally {
      setFormState(form, false);
      keepPageInteractive();
    }
  };

  window.NNLAddProduct = addProduct;
  window.dispatchEvent(new CustomEvent('nnl:cart-ready'));

  if (window.NNLPendingCartForm?.isConnected) {
    addProduct(window.NNLPendingCartForm);
    window.NNLPendingCartForm = null;
  }
})();
